import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  height: 300px;
  width: 100%;
  display: grid;
  place-content: center;
  background-color: #f6f8fa;
  border-radius: 5px;
  margin-block: 20px;
  
`;

const LoadingState = () => {
  return (
    <StyledDiv>
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </StyledDiv>
  );
};

export default LoadingState;
